import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import usePriceManager from '../hooks/use-price-manager'

function InputRadioBox ({size = 'full', updatesPrice = true, beforeUpdateValue = null, name, value}) {
  const manager = usePortManager()
  const price_manager = usePriceManager()
  const settings_manager = useSettingsManager()

  const item_id = name + value
  const checked = manager.getValue(name) === value

  const _settings = settings_manager.getInputOptionSettings(name, value)
  const input_settings = typeof _settings === 'object' ? _settings : { title: value }

  const title = typeof input_settings.title === 'string' ? <div
    className={'input-box__title'}>{input_settings.title}</div> : null
  const description = typeof input_settings.description === 'string' ? <p>{input_settings.description}</p> : null

  const image_url = typeof input_settings.image === 'string' ? input_settings.image : null
  const image = image_url !== null ? <figure style={{ backgroundImage: `url(${image_url})` }}
                                             className={'input-box__image'}></figure> : null

  const classNames = image_url !== null ? 'input-radio-box input-box input-box--image' : 'input-radio-box input-box input-box--center'

  const onchange = function () {
    let update = true
    if (typeof beforeUpdateValue === 'function') {
      update = beforeUpdateValue(name, value)
    }
    if (update !== false) {
      manager.updateValue(name, value)

      if (updatesPrice) {
        price_manager.updatePrice()
      }
    }
  }

  return (
    <aside className={classNames} data-size={size}>
      <input id={item_id} type={'radio'} name={name} value={value} checked={checked} onChange={onchange}/>
      <label htmlFor={item_id}>
        {image}
        <div>
          {title}
          {description}
        </div>
      </label>
    </aside>
  )
}

export default observer(InputRadioBox)